var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../core/runtime/src';
import LegacyClassBuilder from '../../../core/utils/src/class-builders/legacy';
import { Icon } from '../../icon/src';
var iconClassName = function (position, handler) {
    var classNames = ['awsui-input-icon', "awsui-input-icon-" + position];
    if (handler) {
        classNames.push('awsui-input-icon-hoverable');
    }
    return classNames.join(' ');
};
export default (function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'text' : _b, value = _a.value, autocomplete = _a.autocomplete, disabled = _a.disabled, readonly = _a.readonly, disableBrowserAutocorrect = _a.disableBrowserAutocorrect, inputmode = _a.inputmode, leftIcon = _a.leftIcon, _c = _a.leftIconVariant, leftIconVariant = _c === void 0 ? 'subtle' : _c, onLeftIconClick = _a.onLeftIconClick, invalid = _a["aria-invalid"], required = _a["aria-required"], rightIcon = _a.rightIcon, _d = _a.rightIconVariant, rightIconVariant = _d === void 0 ? 'normal' : _d, onRightIconClick = _a.onRightIconClick, additionalAttrs = _a.additionalAttrs;
    var cb = new LegacyClassBuilder({});
    cb.addClass('awsui-input');
    cb.addClass('awsui-input-readonly', readonly);
    cb.addClass("awsui-input-type-" + type);
    if (invalid !== null) {
        cb.addClass('awsui-input-invalid', invalid);
        cb.addClass('awsui-input-valid', !invalid);
    }
    cb.addClass('awsui-input-has-icon-right', rightIcon);
    cb.addClass('awsui-input-has-icon-left', leftIcon);
    var attributes = __assign(__assign({}, additionalAttrs), { autocomplete: autocomplete === true ? 'on' : autocomplete || 'off', className: cb.toClassName(), disabled: disabled,
        readonly: readonly,
        inputmode: inputmode,
        type: type, value: value || '' });
    if (disableBrowserAutocorrect) {
        attributes['autocorrect'] = 'off';
        attributes['autocapitalize'] = 'off';
    }
    // ensure aria properties are string literal "true"
    if (required) {
        attributes['aria-required'] = 'true';
    }
    if (invalid) {
        attributes['aria-invalid'] = 'true';
    }
    return (AwsUi.__createElement("div", { className: "awsui-input-container" },
        leftIcon && (AwsUi.__createElement("span", { onclick: onLeftIconClick },
            AwsUi.__createElement(Icon, { className: iconClassName('left', onLeftIconClick), name: leftIcon, variant: disabled ? 'disabled' : leftIconVariant }))),
        AwsUi.__createElement("input", __assign({}, attributes, { spellcheck: false })),
        rightIcon && (AwsUi.__createElement("span", { onclick: onRightIconClick },
            AwsUi.__createElement(Icon, { className: iconClassName('right', onRightIconClick), name: rightIcon, variant: disabled ? 'disabled' : rightIconVariant })))));
});
//# sourceMappingURL=base-input.js.map